// @flow
import React, { Component } from 'react';
import {
  Text, TextArea, Checkbox, Radio, RadioGroup,
} from 'informed';

import { PrimaryText, SecondaryText } from '../../../Typography.jsx';
import ContentBox from '../../../ContentBox.jsx';
import DatetimeText from '../../../DatetimeText.jsx';

import styles from '../../../../styles/patientPages/progressNote/progressNote.scss';

type Props = {
  neurological: Object,
}

class ViewNeurological extends Component<Props> {
  render() {
    const neurological = this.props.neurological || {};
    return (
      <ContentBox title='Neurological'>
        <div className={styles.col}>
          <PrimaryText>Level of Consciousness/Orientation</PrimaryText>
          <div className={styles.section}>
            <Checkbox field='neurological.orientedAll' initialValue={neurological.orientedAll} />Oriented to person, place, time, and situation
          </div>
          <div className={styles.section}>
            <SecondaryText>Mark all that apply:</SecondaryText><br />
            <Checkbox field='neurological.alert' initialValue={neurological.alert} />Alert/responds readily<br />
            <Checkbox field='neurological.orientedPerson' initialValue={neurological.orientedPerson} />Oriented to person<br />
            <Checkbox field='neurological.orientedPlace' initialValue={neurological.orientedPlace} />Oriented to place<br />
            <Checkbox field='neurological.orientedTime' initialValue={neurological.orientedTime} />Oriented to time<br />
            <Checkbox field='neurological.orientedSituation' initialValue={neurological.orientedSituation} />Oriented to situation<br />
            <Checkbox field='neurological.confusedAtTimes' initialValue={neurological.confusedAtTimes} />Confused at times<br />
            <Checkbox field='neurological.confusedAllTimes' initialValue={neurological.confusedAllTimes} />Confused at all times<br />
            <Checkbox field='neurological.disoriented' initialValue={neurological.disoriented} />Disoriented<br />
            <Checkbox field='neurological.lethargic' initialValue={neurological.lethargic} />Lethargic (slow to respond to verbal stimuli)<br />
            <Checkbox field='neurological.obtunded' initialValue={neurological.obtunded} />Obtunded (very drowsy, responds to touch stimuli)<br />
            <Checkbox field='neurological.semicomatose' initialValue={neurological.semicomatose} />Semicomatose (responds only to painful stimuli)<br />
            <Checkbox field='neurological.comatose' initialValue={neurological.comatose} />Comatose (unresponsive to any stimuli)<br />
            <Checkbox field='neurological.unableToAssessConcious' initialValue={neurological.unableToAssessConscious} />Unable to assess, explain in Notes
          </div>
          <div className={styles.section}>
            <SecondaryText>Level of consciousness/orientation notes:</SecondaryText><br />
            <TextArea field='neurological.orientationNotes' initialValue={neurological.orientationNotes} />
          </div>
          <PrimaryText>Emotional State</PrimaryText>
          <div className={styles.section}>
            <SecondaryText>mark all that apply:</SecondaryText><br />
            <Checkbox field='neurological.calm' initialValue={neurological.calm} />Calm<br />
            <Checkbox field='neurological.cooperative' initialValue={neurological.cooperative} />Cooperative<br />
            <Checkbox field='neurological.happy' initialValue={neurological.happy} />Happy<br />
            <Checkbox field='neurological.uncooperative' initialValue={neurological.uncooperative} />Uncooperative<br />
            <Checkbox field='neurological.combative' initialValue={neurological.combative} />Combative<br />
            <Checkbox field='neurological.anxious' initialValue={neurological.anxious} />Anxious<br />
            <Checkbox field='neurological.sad' initialValue={neurological.sad} />Sad<br />
            <Checkbox field='neurological.crying' initialValue={neurological.crying} />Crying<br />
            <Checkbox field='neurological.agitated' initialValue={neurological.agitated} />Agitated<br />
            <Checkbox field='neurological.restless' initialValue={neurological.restless} />Restless<br />
            <Checkbox field='neurological.angry' initialValue={neurological.angry} />Angry<br />
            <Checkbox field='neurological.hostile' initialValue={neurological.hostile} />Hostile<br />
            <Checkbox field='neurological.distressed' initialValue={neurological.distressed} />Distressed<br />
            <Checkbox field='neurological.withdrawn' initialValue={neurological.withdrawn} />Withdrawn<br />
            <Checkbox field='neurological.noEyeContact' initialValue={neurological.noEyeContact} />No eye contact<br />
            <Checkbox field='neurological.flatAffect' initialValue={neurological.flatAffect} />Flat affect<br />
            <Checkbox field='neurological.labile' initialValue={neurological.labile} />Labile
          </div>
          <div className={styles.section}>
            <SecondaryText>Emotional state notes:</SecondaryText><br />
            <TextArea field='neurological.emotionalStateNotes' initialValue={neurological.emotionalStateNotes} />
          </div>
          <PrimaryText>Hand Grip</PrimaryText>
          <div className={styles.section}>
            <SecondaryText>Bilateral assessment:</SecondaryText><br />
            <RadioGroup field='neurological.handBilateralAssessment' initialValue={neurological.handBilateralAssessment}>
              <Radio value='equal' />Equal<br />
              <Radio value='unequal' />Unequal<br />
              <Radio value='unable' />Unable to assess, explain in Notes
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Right hand grip strength:</SecondaryText><br />
            <RadioGroup field='neurological.rightHandGrip' initialValue={neurological.rightHandGrip}>
              <Radio value='strong' />Strong<br />
              <Radio value='weak' />Weak<br />
              <Radio value='none' />None
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Left hand grip strength:</SecondaryText><br />
            <RadioGroup field='neurological.leftHandGrip' initialValue={neurological.leftHandGrip}>
              <Radio value='strong' />Strong<br />
              <Radio value='weak' />Weak<br />
              <Radio value='none' />None
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Hand grip notes:</SecondaryText><br />
            <TextArea field='neurological.handGripNotes' initialValue={neurological.handGripNotes} />
          </div>
          <PrimaryText>Foot Strength</PrimaryText>
          <div className={styles.section}>
            <SecondaryText>Bilateral assessment:</SecondaryText><br />
            <RadioGroup field='neurological.footBilateralAssessment' initialValue={neurological.footBilateralAssessment}>
              <Radio value='equal' />Equal<br />
              <Radio value='unequal' />Unequal<br />
              <Radio value='unable' />Unable to assess, explain in Notes
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Right foot strength:</SecondaryText><br />
            <RadioGroup field='neurological.rightFootStrength' initialValue={neurological.rightFootStrength}>
              <Radio value='strong' />Strong<br />
              <Radio value='weak' />Weak<br />
              <Radio value='none' />None
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Left foot strength:</SecondaryText><br />
            <RadioGroup field='neurological.leftFootStrength' initialValue={neurological.leftFootStrength}>
              <Radio value='strong' />Strong<br />
              <Radio value='weak' />Weak<br />
              <Radio value='none' />None
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Foot strength notes:</SecondaryText><br />
            <TextArea field='neurological.footStrengthNotes' initialValue={neurological.footStrengthNotes} />
          </div>
          <PrimaryText>Central Nervous System (CNS)</PrimaryText>
          <div className={styles.section}>
            <Checkbox field='neurological.noCNSProblems' initialValue={neurological.noCNSProblems} />No CNS problems evident
          </div>
          <div className={styles.section}>
            <SecondaryText>Mark all that apply:</SecondaryText><br />
            <Checkbox field='neurological.headache' initialValue={neurological.headache} />Headache<br />
            <Checkbox field='neurological.syncope' initialValue={neurological.syncope} />Syncope<br />
            <Checkbox field='neurological.seizures' initialValue={neurological.seizures} />Seizures<br />
            <Checkbox field='neurological.tremors' initialValue={neurological.tremors} />Tremors<br />
            <Checkbox field='neurological.vertigo' initialValue={neurological.vertigo} />Vertigo<br />
            <Checkbox field='neurological.restlessness' initialValue={neurological.restlessness} />Restlessness<br />
            <Checkbox field='neurological.nystagmus' initialValue={neurological.nystagmus} />Nystagmus<br />
            <Checkbox field='neurological.tingling' initialValue={neurological.tingling} />Tingling<br />
            <Checkbox field='neurological.numbness' initialValue={neurological.numbness} />Numbness<br />
            <Checkbox field='neurological.weakness' initialValue={neurological.weakness} />Weakness on affected side<br />
            <Checkbox field='neurological.doesNotMoveExtreme' initialValue={neurological.doesNotMoveExtreme} />Does not move extremities on command<br />
            <Checkbox field='neurological.doesNotFollow' initialValue={neurological.doesNotFollow} />Does not follow commands<br />
            <Checkbox field='neurological.coordinationDifficult' initialValue={neurological.coordinationDifficult} />Coordination difficulties<br />
            <Checkbox field='neurological.checkReflexes' initialValue={neurological.checkReflexes} />Check reflexes<br />
            <Checkbox field='neurological.purposelessMovements' initialValue={neurological.purposelessMovements} />Purposeless movements<br />
            <Checkbox field='neurological.paralysis' initialValue={neurological.paralysis} />Paralysis<br />
            <Checkbox field='neurological.localizesPain' initialValue={neurological.localizesPain} />Localizes pain<br />
            <Checkbox field='neurological.withdrawsFromPain' initialValue={neurological.withdrawsFromPain} />Withdraws only from pain<br />
            <Checkbox field='neurological.decorPosture' initialValue={neurological.decorPosture} />Decorticate posturing<br />
            <Checkbox field='neurological.decerebPosture' initialValue={neurological.decerebPosture} />Decerebrate posturing<br />
            <Checkbox field='neurological.flaccidity' initialValue={neurological.flaccidity} />Flaccidity<br />
            <Checkbox field='neurological.intracranialMonitoring' initialValue={neurological.intracranicalMonitoring} />Intracranial pressure monitoring<br />
            <Checkbox field='neurological.hyperreflexia' initialValue={neurological.hyperreflexia} />Hyperreflexia<br />
            <Checkbox field='neurological.dysphagia' initialValue={neurological.dysphagia} />Dysphagia<br />
            <Checkbox field='neurological.slurred' initialValue={neurological.slurred} />Slurred speech<br />
          </div>
          <div className={styles.section}>
            <SecondaryText>CNS notes:</SecondaryText><br />
            <TextArea field='neurological.CNSNotes' initialValue={neurological.CNSNotes} />
          </div>
          <PrimaryText>Extrapyramidal Side Effects (EPS)</PrimaryText><br />
          <PrimaryText>Akathisia</PrimaryText>
          <div className={styles.section}>
            <SecondaryText>Psychomotor restlessness (mark all that apply):</SecondaryText><br />
            <Checkbox field='neurological.pacing' initialValue={neurological.pacing} />Pacing<br />
            <Checkbox field='neurological.fidgeting' initialValue={neurological.fidgeting} />Fidgeting<br />
            <Checkbox field='neurological.tappingFoot' initialValue={neurological.tappingFoot} />Tapping foot<br />
            <Checkbox field='neurological.rocking' initialValue={neurological.rocking} />Rocking forward and backward<br />
            <Checkbox field='neurological.otherPsychomotor' initialValue={neurological.otherPsychomotor} />Other
          </div>
          <PrimaryText>Acute Dystonia</PrimaryText>
          <div className={styles.section}>
            <SecondaryText>Sustained contractions of the muscles in the head and neck, possibly causing blockage of the trachea (mark all that apply):</SecondaryText><br />
            <Checkbox field='neurological.headBent' initialValue={neurological.headBent} />Head bent to side<br />
            <Checkbox field='neurological.eyesLocked' initialValue={neurological.eyesLocked} />Eyes locked upward<br />
            <Checkbox field='neurological.difficultyBreathing' initialValue={neurological.difficultyBreathing} />Difficulty breathing<br />
            <Checkbox field='neurological.otherDystonia' initialValue={neurological.otherDystonia} />Other<br />
          </div>
          <PrimaryText>Pseudoparkinsonism</PrimaryText>
          <div className={styles.section}>
            <SecondaryText>Stiffened muscles (mark all that apply):</SecondaryText><br />
            <Checkbox field='neurological.pillRolling' initialValue={neurological.pillRolling} />Pill rolling phenomenon<br />
            <Checkbox field='neurological.shufflingGait' initialValue={neurological.shufflingGait} />Shuffling gait<br />
            <Checkbox field='neurological.masklike' initialValue={neurological.masklike} />Masklike face<br />
            <Checkbox field='neurological.stooped' initialValue={neurological.stooped} />Stooped posture<br />
            <Checkbox field='neurological.cogwheel' initialValue={neurological.cogwheel} />Cogwheel rigidity<br />
            <Checkbox field='neurological.otherStiffened' initialValue={neurological.otherStiffened} />Other
          </div>
          <PrimaryText>Tardive Dyskinesia</PrimaryText>
          <div className={styles.section}>
            <SecondaryText>Involuntary muscle contractions (mark all that apply):</SecondaryText><br />
            <Checkbox field='neurological.tongueProtrusion' initialValue={neurological.tongueProtrusion} />Tongue protrusion<br />
            <Checkbox field='neurological.spastic' initialValue={neurological.spastic} />Spastic facial distortion<br />
            <Checkbox field='neurological.smacking' initialValue={neurological.smacking} />Smacking movement of lips<br />
            <Checkbox field='neurological.irregularMovement' initialValue={neurological.irregularMovement} />Irregular body movements<br />
            <Checkbox field='neurological.dramaticJerks' initialValue={neurological.dramaticJerks} />Dramatic hip jerks<br />
            <Checkbox field='neurological.otherInvoluntary' initialValue={neurological.otherInvoluntary} />Other
          </div>
          <PrimaryText>Neuroleptic Malignant Syndrome (NMS)</PrimaryText>
          <div className={styles.section}>
            <SecondaryText>Mark all that apply:</SecondaryText><br />
            <Checkbox field='neurological.severeRigidity' initialValue={neurological.severeRigidity} />Severe muscle rigidity<br />
            <Checkbox field='neurological.oculogyric' initialValue={neurological.oculogyric} />Oculogyric crisis<br />
            <Checkbox field='neurological.dysphasia' initialValue={neurological.dysphasia} />Dysphasia<br />
            <Checkbox field='neurological.cogwheeling' initialValue={neurological.cogwheeling} />Cogwheeling<br />
            <Checkbox field='neurological.elevatedTemp' initialValue={neurological.elevatedTemp} />Elevated temperature greater than 103 degrees Fahrenheit<br />
            <Checkbox field='neurological.hypertension' initialValue={neurological.hypertension} />Hypertension<br />
            <Checkbox field='neurological.diaphoresis' initialValue={neurological.diaphoresis} />Diaphoresis<br />
            <Checkbox field='neurological.incontinence' initialValue={neurological.incontinence} />Incontinence
          </div>
          <PrimaryText>Neurological Checks - Neurological Evaluation</PrimaryText><br />
          <PrimaryText>Pupil Reaction</PrimaryText>
          <div className={styles.section}>
            <SecondaryText>Left pupil reaction to light:</SecondaryText><br />
            <RadioGroup field='neurological.leftPupilReaction' initialValue={neurological.leftPupilReaction}>
              <Radio value='brisk' />Brisk<br />
              <Radio value='sluggish' />Sluggish<br />
              <Radio value='fixed' />Fixed<br />
              <Radio value='blown' />Blown
            </RadioGroup>
            <br />
            <br />
            <Checkbox field='neurological.leftPupilNoReact' initialValue={neurological.leftPupilNoReact} />Non-reactive to light
          </div>
          <div className={styles.section}>
            <SecondaryText>Right pupil reaction to light:</SecondaryText><br />
            <RadioGroup field='neurological.rightPupilReaction' initialValue={neurological.rightPupilReaction}>
              <Radio value='brisk' />Brisk<br />
              <Radio value='sluggish' />Sluggish<br />
              <Radio value='fixed' />Fixed<br />
              <Radio value='blown' />Blown
            </RadioGroup>
            <br />
            <br />
            <Checkbox field='neurological.rightPupilNoReact' initialValue={neurological.rightPupilNoReact} />Non-reactive to light
          </div>
          <PrimaryText>Pupil Size</PrimaryText>
          <div className={styles.section}>
            <SecondaryText>Left pupil size</SecondaryText><br />
            <Checkbox field='neurological.leftPupilRound' initialValue={neurological.leftPupilRound} />Round
            <br />
            <br />
            <RadioGroup field='neurological.leftPupilSize' initialValue={neurological.leftPupilSize}>
              <Radio value='1mm' />1 mm<br />
              <Radio value='2mm' />2 mm<br />
              <Radio value='3mm' />3 mm<br />
              <Radio value='4mm' />4 mm<br />
              <Radio value='5mm' />5 mm<br />
              <Radio value='6mm' />6 mm<br />
              <Radio value='7mm' />7 mm<br />
              <Radio value='8mm' />8 mm<br />
              <Radio value='9mm' />9 mm
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Right pupil size</SecondaryText><br />
            <Checkbox field='neurological.rightPupilRound' initialValue={neurological.RightPupilRound} />Round
            <br />
            <br />
            <RadioGroup field='neurological.rightPupilSize' initialValue={neurological.RightPupilSize}>
              <Radio value='1mm' />1 mm<br />
              <Radio value='2mm' />2 mm<br />
              <Radio value='3mm' />3 mm<br />
              <Radio value='4mm' />4 mm<br />
              <Radio value='5mm' />5 mm<br />
              <Radio value='6mm' />6 mm<br />
              <Radio value='7mm' />7 mm<br />
              <Radio value='8mm' />8 mm<br />
              <Radio value='9mm' />9 mm
            </RadioGroup>
          </div>
          <PrimaryText>Limb Movement</PrimaryText>
          <div className={styles.section}>
            <SecondaryText>Arm movement</SecondaryText><br />
            <RadioGroup field='neurological.armMovement' initialValue={neurological.armMovement}>
              <Radio value='expected' />Expected Movement for Patient<br />
              <Radio value='sluggish' />Sluggish or Weak Movement for Patient<br />
              <Radio value='spastic' />Spastic Flexion (Decorticate Posturing)<br />
              <Radio value='extension' />Extension (Decerebrate Posturing)<br />
              <Radio value='no response' />No Response
            </RadioGroup>
          </div>
          <div className={styles.section}>
            <SecondaryText>Leg movement</SecondaryText><br />
            <RadioGroup field='neurological.legMovement' initialValue={neurological.legMovement}>
              <Radio value='expected' />Expected Movement for Patient<br />
              <Radio value='sluggish' />Sluggish or Weak Movement for Patient<br />
              <Radio value='spastic' />Spastic Flexion (Decorticate Posturing)<br />
              <Radio value='extension' />Extension (Decerebrate Posturing)<br />
              <Radio value='no response' />No Response
            </RadioGroup>
          </div>
          <PrimaryText>Coma Status</PrimaryText>
          <div className={styles.section}>
            <RadioGroup field='neurological.comaStatus' initialValue={neurological.comaStatus}>
              <Radio value='conscious' />Conscious = Oriented to person, place, and time<br />
              <Radio value='semi-conscious' />Semi-conscious = Can respond to simple commands<br />
              <Radio value='light coma' />Light Coma = Responds only to painful stimulus but corneal and gag reflexes are intact<br />
              <Radio value='deep coma' />Deep Coma = Does not respond to painful stimulus and corneal and gag reflexes are not intact
            </RadioGroup>
          </div>
          <PrimaryText>Neurological Checks - Glasgow Coma Scale</PrimaryText>
          <div className={styles.section}>
            The Glasgow Coma Scale is based on a 15 points scale for estimating and categorizing the outcomes of brain injury on the basis of overall social capability or dependence on others.
          </div>
          <PrimaryText>Eye Opening Response</PrimaryText>
          <div className={styles.section}>
            <SecondaryText>Degree to which patient is able to open eyes</SecondaryText><br />
            <SecondaryText>NOTE: For severe facial/eye swelling, choose a score of 1 and check the &quot;Eye&quot; checkbox.</SecondaryText><br />
            <RadioGroup field='neurological.eyeOpeningResponse' initialValue={neurological.eyeOpeningResponse}>
              <Radio value='4' />4 (Spontaneous) = Spontaneously opens eyes<br />
              <Radio value='3' />3 (To Verbal Command) = Opens eyes to verbal command<br />
              <Radio value='2' />2 (To Pain) = Opens eyes to painful stimuli such as sternal rub<br />
              <Radio value='1' />1 (No Response) = Does not open eyes to verbal command or painful stimuli
            </RadioGroup>
            <br />
            <br />
            <Checkbox field='neurological.eyeCheckBox' initialValue={neurological.eyeCheckBox} />Eye
          </div>
          <PrimaryText>Best Motor Response</PrimaryText>
          <div className={styles.section}>
            <SecondaryText>Degree to which patient is able to control motor movements</SecondaryText><br />
            <RadioGroup field='neurological.bestMotorResponse' initialValue={neurological.bestMotorResponse}>
              <Radio value='6' />6 (Obeys Motor Command) = Able to control motor movements such as &quot;Hold out 3 fingers&quot;<br />
              <Radio value='5' />5 (Localizes Pain) = Able to localize pain<br />
              <Radio value='4' />4 (Withdraws in Response to Pain)<br />
              <Radio value='3' />3 (Responds to pain with decorticate posturing/abnormal flexion)<br />
              <Radio value='2' />2 (Responds to pain with decerebrate posturing/abnormal extension)<br />
              <Radio value='1' />1 (No Response) = Does not respond in any way to painful stimulus
            </RadioGroup>
          </div>
          <PrimaryText>Best Verbal Response</PrimaryText>
          <div className={styles.section}>
            <SecondaryText>Degree to which patient is able to converse with others</SecondaryText><br />
            <SecondaryText>NOTE: For intubated patients, choose a score of 1 and check the &quot;Tube&quot; checkbox.</SecondaryText><br />
            <RadioGroup field='neurological.bestVerbalResponse' initialValue={neurological.bestVerbalResponse}>
              <Radio value='5' />5 (Oriented and converses) = Able to converse with others<br />
              <Radio value='4' />4 (Converses but is confused or disoriented)<br />
              <Radio value='3' />3 (Inappropriate words) = Cannot carry on meaningful conversation<br />
              <Radio value='2' />2 (Incomprehensible words) = Cannot make self understood due to incomprehensible speech<br />
              <Radio value='1' />1 (No Response) = Does not respond verbally
            </RadioGroup>
            <br />
            <br />
            <Checkbox field='neurological.intubated' initialValue={neurological.intubated} />Intubated
          </div>
          <PrimaryText>Total Glasgow Score</PrimaryText>
          <div className={styles.section}>
            <Text field='neurological.glasgowTotal' initialValue={neurological.glasgowTotal} size={4} /><br />
          </div>
          <PrimaryText>Seizure Activity Documentation</PrimaryText><br />
          <PrimaryText>Onset</PrimaryText>
          <div className={styles.section}>
            <table>
              <tbody>
                <tr>
                  <td>
                    <SecondaryText>Day/time: </SecondaryText>
                  </td>
                  <td>
                    <DatetimeText field='neurological.seizureDateTime' initialValue={neurological.seizureDateTime} initEmpty size={24} />
                  </td>
                </tr>
                <tr>
                  <td>
                    <SecondaryText>Duration of seizure: </SecondaryText>
                  </td>
                  <td>
                    <Text field='neurological.seizureDuration' initialValue={neurological.seizureDuration} size={24} />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <PrimaryText>Precipitating Events</PrimaryText>
          <div className={styles.section}>
            <Checkbox field='neurological.missedMeds' initialValue={neurological.missedMeds} />Missed medication dosage<br />
            <Checkbox field='neurological.illness' initialValue={neurological.illness} />Illness<br />
            <Checkbox field='neurological.stressfulProcedure' initialValue={neurological.stressfulProcedure} />Stressful procedure<br />
            <Checkbox field='neurological.sleepDepriv' initialValue={neurological.sleepDepriv} />Sleep deprivation<br />
            <Checkbox field='neurological.menses' initialValue={neurological.menses} />Menses<br />
            <Checkbox field='neurological.otherEvent' initialValue={neurological.otherEvent} />Other
          </div>
          <div className={styles.section}>
            <SecondaryText>Aura:</SecondaryText><br />
            <RadioGroup field='neurological.aura' initialValue={neurological.aura}>
              <Radio value='yes' />Yes<br />
              <Radio value='no' />No
            </RadioGroup>
          </div>
          <PrimaryText>Type of Seizure</PrimaryText>
          <div className={styles.section}>
            <Checkbox field='neurological.partial' initialValue={neurological.partial} />Partial<br />
            <Checkbox field='neurological.simplePartial' initialValue={neurological.simplePartial} />Simple partial<br />
            <Checkbox field='neurological.complexPartial' initialValue={neurological.complexPartial} />Complex partial<br />
            <Checkbox field='neurological.tonicClonic' initialValue={neurological.tonicClonic} />Tonic-clonic<br />
            <Checkbox field='neurological.absence' initialValue={neurological.absence} />Absence<br />
            <Checkbox field='neurological.atonicKinetic' initialValue={neurological.atonicKinetic} />Atonic/kinetic<br />
            <Checkbox field='neurological.myoclonic' initialValue={neurological.myoclonic} />Myoclonic<br />
            <Checkbox field='neurological.tonic' initialValue={neurological.tonic} />Tonic<br />
            <Checkbox field='neurological.clonic' initialValue={neurological.clonic} />Clonic<br />
            <Checkbox field='neurological.infantileSpasms' initialValue={neurological.infantileSpasms} />Infantile spasms<br />
            <Checkbox field='neurological.febrile' initialValue={neurological.febrile} />Febrile
          </div>
          <PrimaryText>Description of Seizure Activity</PrimaryText>
          <div className={styles.section}>
            <Checkbox field='neurological.tonicClonicMovements' initialValue={neurological.tonicClonicMovements} />Tonic-clonic movements<br />
            <Checkbox field='neurological.unilateralLeft' initialValue={neurological.unilateralLeft} />Unilateral left side<br />
            <Checkbox field='neurological.unilateralRight' initialValue={neurological.unilateralRight} />Unilateral right side<br />
            <Checkbox field='neurological.salivation' initialValue={neurological.salivation} />Salivation<br />
            <Checkbox field='neurological.arrestedSpeech' initialValue={neurological.arrestedSpeech} />Arrested speech<br />
            <Checkbox field='neurological.facialInvolvement' initialValue={neurological.facialInvolvement} />Facial involvement<br />
            <Checkbox field='neurological.eyesRollUp' initialValue={neurological.eyesRollUp} />Eyes roll upward<br />
            <Checkbox field='neurological.eyesDeviate' initialValue={neurological.eyesDeviate} />Eyes deviate to one side<br />
            <Checkbox field='neurological.stiffened' initialValue={neurological.stiffened} />stiffened<br />
            <Checkbox field='neurological.lossConscious' initialValue={neurological.lossConscious} />Loss of consciousness<br />
            <Checkbox field='neurological.symmetric' initialValue={neurological.symmetric} />Symmetric<br />
            <Checkbox field='neurological.rhythmic' initialValue={neurological.rhythmic} />Rhythmic<br />
            <Checkbox field='neurological.violentJerk' initialValue={neurological.violentJerk} />Violent jerking<br />
            <Checkbox field='neurological.lipSmacking' initialValue={neurological.lipSmacking} />Lip smacking<br />
            <Checkbox field='neurological.twitchingFace' initialValue={neurological.twitchingFace} />Twitching: Face<br />
            <Checkbox field='neurological.twitchingEyelids' initialValue={neurological.twitchingEyelids} />Twitching: Eyelids<br />
            <Checkbox field='neurological.twitchingHands' initialValue={neurological.twitchingHands} />Twitching: Hands<br />
            <Checkbox field='neurological.cryingOut' initialValue={neurological.cryingOut} />Crying out<br />
            <Checkbox field='neurological.extensorSpasms' initialValue={neurological.extensorSpasms} />Extensor spasms<br />
            <Checkbox field='neurological.bicycling' initialValue={neurological.bicycling} />Bicycling
          </div>
          <div className={styles.section}>
            <table>
              <tbody className={styles.topAlign}>
                <tr>
                  <td><SecondaryText>Apnea:</SecondaryText></td>
                  <td>
                    <RadioGroup field='neurological.apnea' initialValue={neurological.apnea}>
                      <Radio value='yes' />Yes<br />
                      <Radio value='no' />No
                    </RadioGroup>
                  </td>
                </tr>
                <tr>
                  <td><SecondaryText>Length of apnea:</SecondaryText></td>
                  <td>
                    <Text field='neurological.apneaLength' initialValue={neurological.apneaLength} />
                  </td>
                </tr>
                <tr>
                  <td><SecondaryText>Incontinence: </SecondaryText></td>
                  <td>
                    <RadioGroup field='neurological.seizureIncontinence' initialValue={neurological.seizureIncontinence}>
                      <Radio value='yes' />Yes<br />
                      <Radio value='no' />No
                    </RadioGroup>
                  </td>
                </tr>
                <tr>
                  <td><SecondaryText>Duration of postictal stage:</SecondaryText></td>
                  <td>
                    <Text field='neurological.postictalLength' initialValue={neurological.postictalLength} />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </ContentBox>
    );
  }
}

export default ViewNeurological;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/progressNote/view/ViewNeurological.jsx